import { render, staticRenderFns } from "./search_results_new.vue?vue&type=template&id=16f11842&scoped=true"
import script from "./search_results_new.vue?vue&type=script&lang=js"
export * from "./search_results_new.vue?vue&type=script&lang=js"
import style0 from "./search_results_new.vue?vue&type=style&index=0&id=16f11842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f11842",
  null
  
)

export default component.exports